import React from 'react'
import AmendmentConfigForm from './AmendmentConfigForm'
import ConvertLeadConfigForm from './ConvertLeadConfigForm'
import DealSelectorForm from './DealSelectorForm'
import LeadSelectorForm from './LeadSelectorForm'
import MajorVersionConfigForm from './MajorVersionConfigForm'
import RoadmapConfigForm from './RoadmapConfigForm'
import RoadmapRevisionForm from './RoadmapRevisionForm'
import VersionTypeSelector from './VersionTypeSelector'

export interface StepFormConfig {
  type: string
  title?: string
  [key: string]: any
}

interface StepFormRendererProps {
  config: StepFormConfig
  onAction: (text: string) => void
  deals: any[]
  organizations: any[]
  leads: any[]
  isInteractive: boolean
}

const StepFormRenderer: React.FC<StepFormRendererProps> = ({
  config,
  onAction,
  deals,
  organizations,
  leads,
  isInteractive,
}) => {
  switch (config.type) {
    case 'lead-selector':
      return (
        <LeadSelectorForm
          title={config.title || 'Select a lead to convert'}
          leads={leads}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    case 'convert-lead-config':
      return (
        <ConvertLeadConfigForm
          title={config.title || 'Configure Lead Conversion'}
          leadName={config.leadName || ''}
          leadCompany={config.leadCompany || ''}
          leadUuid={config.leadUuid || ''}
          matchedOrg={config.matchedOrg || null}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    case 'deal-selector':
      return (
        <DealSelectorForm
          title={config.title || 'Select a deal'}
          filter={config.filter}
          deals={deals}
          organizations={organizations}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    case 'amendment-config':
      return (
        <AmendmentConfigForm
          title={config.title || 'Configure Amendment'}
          changeType={config.changeType || 'minor'}
          dealPK={config.dealPK}
          dealSK={config.dealSK}
          dealName={config.dealName}
          currentVersion={config.currentVersion}
          deals={deals}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    case 'version-type-selector':
      return (
        <VersionTypeSelector
          title={config.title || 'What kind of revision?'}
          dealPK={config.dealPK}
          dealSK={config.dealSK}
          dealName={config.dealName}
          currentVersion={config.currentVersion}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    case 'major-version-config':
      return (
        <MajorVersionConfigForm
          title={config.title || 'Configure Major Version'}
          dealPK={config.dealPK}
          dealSK={config.dealSK}
          dealName={config.dealName}
          currentVersion={config.currentVersion}
          currentProducts={config.currentProducts}
          deals={deals}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    case 'roadmap-config':
      return (
        <RoadmapConfigForm
          title={config.title || 'Configure Roadmap'}
          onSubmit={onAction}
          isInteractive={isInteractive}
          organizations={organizations}
        />
      )

    case 'roadmap-revision':
      return (
        <RoadmapRevisionForm
          title={config.title || 'Adjust Roadmap'}
          onSubmit={onAction}
          isInteractive={isInteractive}
        />
      )

    default:
      return null
  }
}

export default StepFormRenderer
